import React from 'react'
import { connect } from 'react-redux'
import Grandmaster from '../components/Grandmaster'
import { getGMProblem, getGMProblemProblemId, viewExplanations } from '../../../redux/modules/grandmaster'
import {toJS} from '../../../util/ToJS'
import {makeSelectTopic} from '../../../redux/modules/topic'
import withExitableNavGM from './WithExitableNavGM'


class VisibleGrandmaster extends React.PureComponent {
  constructor(props) {
    super(props)

  }
  componentDidMount() {
    const {match, getGMProblem, getGMProblemProblemId} = this.props
    const {topicId, problemId} = match.params
    if (problemId && topicId) {
      getGMProblem(topicId,problemId)
    } else if (problemId && topicId === undefined) {
      getGMProblemProblemId(problemId)
    } else {
      getGMProblem(topicId)
    }
  }

  render() {
    return (
      <Grandmaster {...this.props} />
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getGMProblem: (topicId, problemId=0) => {
      dispatch(getGMProblem(topicId,problemId))
    },
    getGMProblemProblemId: (problemId) => {
      dispatch(getGMProblemProblemId(problemId))
    },
    exitExplanations: () => {
      dispatch(viewExplanations(false))
    }
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    return {
      breadcrumbTopics: topic.get('breadcrumbs'),
      topicTitle: topic.get('renderedTitle'),
      topicId: topic.get('id'),
      isViewingExplanations: state.getIn(['grandmaster','isViewingExplanations']),
      viewing: state.getIn(['grandmaster','viewing'])
    }
  }
  return mapStateToProps
}

export default withExitableNavGM(connect(
  makeMapStateToProps,
  mapDispatchToProps
)(toJS(VisibleGrandmaster)))



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGrandmaster.js